import s from './styles';

function IconAndInformation({ top, bottom, icon, style }) {
  return (
    <s.InformationWrapper style={style}>
      <s.IconWrapper>{icon}</s.IconWrapper>
      <s.TextWrapper>
        <s.TopText>{top}</s.TopText>
        <s.BottomText>{bottom}</s.BottomText>{' '}
      </s.TextWrapper>
    </s.InformationWrapper>
  );
}

export default IconAndInformation;
